/* globals exportToExcel, findInArray */
(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('demandSimulation', demandSimulation);

	demandSimulation.$inject = ['$rootScope', '$scope', '$timeout', '$filter', '$stateParams',
		'$translate', '$state', '$location', '$experiments', 'redirectParamsService',
		'leanFilterService', 'formatterService', 'navigationService', 'tableService', 'tableRenderService',
		'pageTimingService', 'shortageCriticalityLevelService', 'storeService'
	];

	function demandSimulation($rootScope, $scope, $timeout, $filter, $stateParams,
			$translate, $state, $location, $experiments, redirectParamsService,
			leanFilterService, formatterService, navigationService, tableService, tableRenderService,
			pageTimingService, shortageCriticalityLevelService, storeService) {
		var vm = this;
		var unsubscribe;

		var isDrillDown = $stateParams.drilldown && $stateParams.drilldown == 1 ? true : false;
		vm.isSupplier = globalConfig.user.role === 'Supplier';
		vm.formatterService = formatterService;
		var reportSettingsName = 'material-shortages/demand-simulation';
		var currentTranslated = 'Current';
		var noneTranslated = 'None';
		var defaultFilters = [{ id: 'factory', values: [globalConfig.factory.id] }];
		var setFirstView = false;

		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;
		var criticalityLevelPromise = undefined;
		var bucketDisplaySet = false;
		var isSpiritSupplier = globalConfig.user.role === 'Supplier' && globalConfig.customer.id === 90;

		init();
		chartFilters();
		var columnList = columns();
		var pinnedColumns = [];
		var displayMap = {};

		$translate(currentTranslated).then(function (tt) {
			currentTranslated = tt;
		});

		$translate(noneTranslated).then(function (tt) {
			noneTranslated = tt;
		});

		vm.reportName = 'Demand scenario modeling';
		vm.hideSearch = false;
		vm.exportToExcel = exportToExcel;
		vm.searchPlaceholderText = 'Search items...';
		vm.showExcel = true;
		vm.initialLoad = true;

		if (!shortageCriticalityLevelService.isLoaded()) {
			criticalityLevelPromise = shortageCriticalityLevelService.loadCriticalityLevels();
		}


		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		var extraParams = [{
			showExcel: true,
			excelReportName: 'DemandSimulationReport',
			selectedList: vm.selectedList
		}];
		var rendererParams = {
			'defaultTab': 'stockSection',
			'specificTaskType': 'task',
			'displayMap': displayMap
		};


		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			noPaging: false,
			columns: columnList,
			pinnedColumns: pinnedColumns,
			setColumnDefaults: true,
			defaultSort: 'firstCriticalBucket',
			defaultSortDirection: 'asc',
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			reportUrl: '{0}/DemandSimulationReport',
			excelReportName: 'DemandSimulationReport',
			excelRequest: true,
			useReportBuilderForExcel: true,
			controllerModifiesColumns: true,
			controllerHandlesFilterLoad: true,
			hasMandatoryFilters: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;

		vm.broadcastExcel = broadcastExcel;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		var excelColumns = [
			{ id: 'itemDescription' },
			{ id: 'replenishmentMethodType' }
		];
		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', { columns: pinnedColumns.concat(excelColumns).concat(columnList), doChooseColumns: true, exportFileName: reportSettingsId ? vm.reportName : undefined });
		}

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});
		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming('Shortages by Item');
				timingCalled = true;
			}
		}

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			
			if (params.sort) {
				_.each(params.sort, function(sorter) {
					if (sorter && sorter.property) {
						sorter.property = sorter.property.replace(/firstCriticalBucket.*/, 'firstCriticalBucket');
					}
				});
			}

			return tableService.postData(params, extraParams, ['itemNdx'])
			.then(function (response) {
				if (vm.initialLoad) {
					$timeout(function () {
						if (reportSettingsName === globalReportName || reportSettingsId === globalReportName) {
							leanFilterService.loadFilters();
							vm.initialLoad = false;
							meta.controllerHandlesFilterLoad = false;
						}
					}, 0);
				}
				if (!reportSettingsId && !setFirstView) {
					var firstViewObj = {
						'viewType': 'shortages'
					};
					navigationService.setFirstView(firstViewObj, reportSettingsName);
					setFirstView = true;
				}
				if (response[0].data && response[0].data[0]) {
					response[1].total = response[0].data[0].row_count;
				}
				updateDisabledColumns(response);
				getDataCalled = true;
				submitUserTiming();
				return response;
			});
		}

		function findColumn(id) {
			var colTemp = _.find(columnList, {id: id});
			return colTemp ? colTemp : _.find(pinnedColumns, {id: id});
		}

		function updateDisabledColumns(response) {
			// Turn on/off weeks/months
			var bucketType = response[0].bucketType || 'weeks';
			rendererParams.bucketType = bucketType;
			findColumn('firstCriticalBucket').disabled = bucketType !== 'weeks';
			findColumn('firstCriticalBucketMonth').disabled = bucketType !== 'months';
			findColumn('firstCriticalBucketDay').disabled = bucketType !== 'days';
			var i, tempColumn;
			for (i = 1; i <= 52; i++) {
				tempColumn = findColumn('bucket' + i + 'quantity');
				if (!tempColumn) {
					displayMap['week' + i + 'quantity'] = 'Day ' + i;
					continue;
				}
				tempColumn.disabled = bucketType !== 'weeks';
				if (!tempColumn.display || !bucketDisplaySet) {
					tempColumn.display = endBucketDates(response, tempColumn.bucketNum);
				}
				if (!displayMap[tempColumn.id]) {
					displayMap[tempColumn.id] = tempColumn.display;
				}
			}
			for (i = 1; i <= 12; i++) {
				tempColumn = findColumn('month' + i + 'quantity');
				tempColumn.disabled = bucketType !== 'months';
				if (!displayMap[tempColumn.id]) {
					displayMap[tempColumn.id] = tempColumn.display;
				}
			}
			for (i = 1; i <= 365; i++) {
				tempColumn = findColumn('day' + i + 'quantity');
				if (!tempColumn) {
					displayMap['day' + i + 'quantity'] = 'Day ' + i;
					continue;
				}
				tempColumn.disabled = bucketType !== 'days';
				if (!tempColumn.display || !bucketDisplaySet) {
					tempColumn.display = dailyBucketDates(response, tempColumn.bucketNum);
				}
				if (!displayMap[tempColumn.id]) {
					displayMap[tempColumn.id] = tempColumn.display;
				}
			}
			bucketDisplaySet = response[0].data.length > 0;
		}

		function chartFilters() {
			if ($stateParams.drilldown) {
				var urlParams = $location.search();
				urlParams.drilldown = 1;
				for (var filterName in $stateParams.filters) {
					if ($stateParams.filters.hasOwnProperty(filterName)) {
						urlParams[filterName] = decodeURIComponent($stateParams.filters[filterName]);
					}
				}
				$location.search(urlParams);
			}
		}

		function init() {
			leanFilterService.clearFilters();
			leanFilterService.useFactoryFilter = true;
			if (!vm.isSupplier && !isDrillDown) {
				defaultFilters = [
					{
						'id': 'factory',
						'values': [globalConfig.factory.id],
						'isMandatory': true
					},
					{
						id: 'demandSimulation',
						value: JSON.stringify([{itemNdx:null, date: new Date(), quantity: 0}]),
						isMandatory: true
					},
					{
						id: 'bucketType',
						values: ['weeks'],
						isMandatory: true
					}
				];
			}

			$scope.useFactoryFilter = true;

			leanFilterService.setMasterSingleSelectFilterList([
				_.extend(leanFilterService.filterDefinitions['Factory'], {
					removable: false,
					type: 'singleSelect'
				}),
				leanFilterService.filterDefinitions['ItemType'],
				_.extend(leanFilterService.filterDefinitions['BucketType'], {
					removable: false
				}),
				leanFilterService.filterDefinitions['ShortageType']
			]);

			leanFilterService.setMasterStringFilterList([
				_.extend(leanFilterService.filterDefinitions['DemandSimulation'], {
					removable: false
				})
			]);

			leanFilterService.setMasterRangeFilterList([
				leanFilterService.filterDefinitions['FirmedOnOrderQuantity'],
				leanFilterService.filterDefinitions['PlannedOnOrderQuantity']
			]);
			
			leanFilterService.setMasterFilterList([
				_.extend(leanFilterService.filterDefinitions['EndItem'], {
					useNotSelected: false
				}),
				leanFilterService.filterDefinitions['Item Group'],
				leanFilterService.filterDefinitions['Supplier'],
				leanFilterService.filterDefinitions['Buyer'],
				_.extend(leanFilterService.filterDefinitions['Planner'], {
					id: 'planner'
				}),
				leanFilterService.filterDefinitions['ERP Order Policy'],
				leanFilterService.filterDefinitions['Responsible'],
				leanFilterService.filterDefinitions['TaskStatus'],
				leanFilterService.filterDefinitions['TaskCategory'],
				leanFilterService.filterDefinitions['MaterialGroup'],
				leanFilterService.filterDefinitions['MaterialType']
			]);

		}

		function endBucketDates(response, bucketNum) {
			if (response[0].data.length === 0) {
				return 'Week ' + bucketNum;
			}
			var bucketKey = 'bucket' + bucketNum + 'endDate';
			var endDate = response[0].data[0][bucketKey];
			var dateMinusOneDay = moment(endDate).subtract(1, 'day').toDate();
			return $filter('date')(dateMinusOneDay, 'mediumDate', 'UTC');
		}

		function dailyBucketDates(response, bucketNum) {
			if (response[0].data.length === 0) {
				return 'Day ' + bucketNum;
			}
			var bucketKey = 'day' + bucketNum + 'date';
			return $filter('date')(response[0].data[0][bucketKey], 'mediumDate', 'UTC');
		}

		function formatNextMonth(numMonths) {
			return moment().add(numMonths, 'months').format('MMM YYYY');
		}

		function getSelectedSites() {
			var selectedSites = leanFilterService.getSelectedIds('factory');
			if (selectedSites.length === 1 && selectedSites[0] === 'LDNA_A_S') {
				selectedSites = [];
				var loggedInCustomerNdx = globalConfig.customer.id;
				for (var key in globalConfig.user.authFacts) {
					if (globalConfig.user.authFacts[key].customerNdx === loggedInCustomerNdx){ 
						selectedSites.push(+key);
					}
				}
			} else if (selectedSites.length === 0) {
				selectedSites.push(globalConfig.factory.id);
			}
			return selectedSites;
		}

		function columns() {
			var cols = [
				{
					id: 'itemCode',
					display: 'Item Code',
					renderer: tableRenderService.itemCode,
					width: 180,
					pinnedLeft: true
				},
				{
					id: 'itemAlias',
					display: 'Item Alias',
					width: 180,
					show: false
				},
				{
					id: 'itemType',
					display: 'Item Type',
					width: 100,
					show: false,
					disabled: vm.isSupplier
				},
				{
					id: 'siteAlias',
					display: 'Site',
					width: 100
				},
				{
					id: 'actionStatus',
					display: 'Task Status',
					renderer: tableRenderService.status,
					show: false,
					width: 120,
					disabled: vm.isSupplier
				}, 
				{
					id: 'actionSubject',
					display: 'Task Subject',
					show: false,
					width: 120,
					sort: false,
					disabled: vm.isSupplier
				}, 
				{
					id: 'actionDescription',
					display: 'Task Description',
					show: false,
					width: 150,
					sort: false,
					renderer: tableRenderService.uiBootstrapTooltip,
					disabled: vm.isSupplier
				},
				{
					id: 'actionCategory',
					display: 'Task Category',
					show: false,
					width: 120,
					disabled: vm.isSupplier,
					renderer: tableRenderService.inlineTaskList,
					idField: 'actionCategoryNdx'
				},
				{
					id: 'actionOwner',
					display: 'Task Responsible',
					renderer: tableRenderService.inlineTaskList,
					show: false,
					width: 120,
					disabled: vm.isSupplier,
					idField: 'actionOwnerNdx'
				},
				{
					id: 'actionDueDate',
					display: 'Task Due Date',
					renderer: tableRenderService.inlineTaskDueDate,
					convertTimeZone: true,
					width: 100,
					statusColumn: 'actionStatus',
					statusForCheckingPastDue: 'Open',
					disabled: vm.isSupplier
				},
				{
					id: 'lastComment',
					display: 'Last Comment',
					show: false,
					width: 120,
					renderer: tableRenderService.inlineTaskComment,
					disabled: vm.isSupplier
				},
				{
					id: 'lastCommenter',
					display: 'Last Commenter',
					show: false,
					width: 120,
					disabled: vm.isSupplier
				},
				{
					id: 'lastCommentDate',
					display: 'Last Comment Date',
					renderer: tableRenderService.dateRenderer,
					convertTimeZone: true,
					show: false,
					width: 120,
					disabled: vm.isSupplier
				},
				{
					id: 'itemGroup',
					display: 'Item Group',
					width: 140
				}, {
					id: 'materialType',
					display: 'Material Type',
					show: false,
					width: 80
				}, {
					id: 'materialGroup',
					display: 'Material Group',
					show: false,
					width: 80
				},
				{
					id: 'endItemCodes',
					display: 'End Items',
					show: true,
					width: 120
				},
				{
					id: 'buyerCode',
					display: 'Buyer',
					width: 140
				},
				{
					id: 'planner',
					display: 'Planner',
					width: 140,
					show: false
				},
				{
					id: 'supplierName',
					display: 'Supplier',
					width: 140
				},
				{
					id: 'orderPolicy',
					display: 'Order Policy',
					width: 80,
					show: false,
					disabled: vm.isSupplier
				},
				{
					id: 'erpOrderPolicy',
					display: 'ERP Order Policy',
					width: 80,
					show: false,
					disabled: vm.isSupplier
				},
				{
					id: 'leadTime',
					display: 'Lead Time',
					renderer: tableRenderService.leadTime,
					width: 80,
					show: false,
					sortDefaultReverse: true,
					disabled: isSpiritSupplier
				},
				{
					id: 'unitOfMeasure',
					display: 'UOM',
					width: 80,
					show: false
				},
				{
					id: 'analysisAvgDailyDemandFloat',
					display: 'Company Defined Demand (Daily)',
					width: 100,
					renderer: tableRenderService.hyperlinkShortage,
					show: false,
					disabled: vm.isSupplier
				},
				{
					id: 'totalOnHandUnrestrictedQuantity',
					display: 'On Hand (Unrestricted)',
					width: 80,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'totalOnHandBlocked',
					display: 'On Hand Blocked',
					width: 100,
					show: false,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'totalOnOrderQuantityFloat',
					display: 'On Order Qty',
					width: 80,
					renderer: tableRenderService.hyperlinkShortage
				},
				{
					id: 'plannedOnOrderQuantity',
					display: 'Planned On Order',
					show: false,
					width: 80,
					renderer: tableRenderService.hyperlinkShortage,
					disabled: vm.isSupplier
				},
				{
					id: 'firmedOnOrderQuantity',
					display: 'Firmed On Order',
					show: false,
					width: 80,
					renderer: tableRenderService.hyperlinkShortage,
					disabled: vm.isSupplier
				},
				{
					id: 'safetyStockFloat',
					display: 'Safety Stock',
					width: 80,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'minLevelFloat',
					display: 'Min Level',
					width: 80,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'maxLevelFloat',
					display: 'Max Level',
					width: 80,
					show: false,
					renderer: tableRenderService.integer
				},
				{
					id: 'pastDueOnOrderQty',
					display: 'Past Due on Order',
					width: 100,
					show: false,
					renderer: tableRenderService.integer,
					disabled: vm.isSupplier
				},
				{
					id: 'pastDueRequirements',
					display: 'Past Due Demand',
					width: 100,
					show: false,
					renderer: tableRenderService.integer,
					disabled: vm.isSupplier
				},
				{
					id: 'totalDemand',
					display: 'Total Demand',
					show: false,
					width: 80,
					renderer: tableRenderService.integer
				},
				{
					id: 'excessAtOtherSites',
					display: 'Excess at Other Sites',
					show: false,
					width: 80,
					renderer: tableRenderService.excessAtOtherSites,
					sortDefaultReverse: true,
					disabled: vm.isSupplier
				},
				{
					id: 'firstCriticalBucket',
					display: 'Week of First Shortage',
					width: 110,
					renderer: tableRenderService.firstCriticalWeek,
					disabled: true
				},
				{
					id: 'firstCriticalBucketMonth',
					display: 'Month of First Shortage',
					width: 110,
					renderer: tableRenderService.firstCriticalMonth,
					disabled: true
				},
				{
					id: 'firstCriticalBucketDay',
					display: 'Day of First Shortage',
					width: 110,
					renderer: tableRenderService.firstCriticalDay,
					disabled: true
				},
				{
					id: 'reqmtToday',
					display: 'Current Shortage',
					width: 100,
					renderer: tableRenderService.bucket
				}
			];
			var i;
			for (i = 1; i <= 32; i++) {
				cols.push({
					id: 'bucket' + i + 'quantity',
					width: 80,
					renderer: tableRenderService.bucket,
					show: i < 17,
					bucketNum: i,
					disabled: true
				});
			}
			for (i = 1; i <= 12; i++) {
				cols.push({
					id: 'month' + i + 'quantity',
					display: formatNextMonth(i - 1),
					width: 80,
					renderer: tableRenderService.bucket,
					monthNum: i,
					disabled: true
				});
			}
			for (i = 1; i <= 45; i++) {
				cols.push({
					id: 'day' + i + 'quantity',
					width: 80,
					renderer: tableRenderService.bucket,
					bucketNum: i,
					disabled: true,
					show: i <= 30
				});
			}
			return cols;
		}
	}
})();
